/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *em
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed May 10 2023
 **/

import { Maybe } from "@/frameworks/libraries/components";

import InviteSpaceChatMember from "./private/InviteSpaceChatMember";
import InviteDMChatMember from "./private/InviteDMChatMember";
import type { ValidateUserEmail } from "./private/InviteDMChatMember";

interface InviteChatMemberProps {
	channelID?: string;
	spaceID?: string;
	chatKind: ChatServices.RoomType;
	onHide: () => void;
	defaultUsersToInvite?: ValidateUserEmail[];
}

export default function InviteChatMember({
	chatKind,
	onHide,
	channelID,
	spaceID,
	defaultUsersToInvite
}: InviteChatMemberProps) {
	return (
		<Maybe
			test={chatKind === "DM"}
			fallback={
				<InviteSpaceChatMember chatKind={chatKind} channelID={channelID} onHide={onHide} spaceID={spaceID} />
			}
		>
			<InviteDMChatMember
				chatKind={chatKind}
				channelID={channelID}
				onHide={onHide}
				defaultUsersToInvite={defaultUsersToInvite}
			/>
		</Maybe>
	);
}
